import {useEffect, useState} from 'react'
import axios from 'axios'
import {useAuth} from '../../modules/auth'

// Re-checks auth/verify-token whenever the user clicks a button, link, header or input,
// and logs them out if their account has been deactivated in the meantime.
export const useVerifyTokenOnClick = () => {
  const API_URL = process.env.REACT_APP_KT_API_URL
  const {setCurrentUser, logout, saveAuth} = useAuth()
  const [domButtonClicked, setDomButtonClicked] = useState(false)

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const el: any = event.target as HTMLElement
      const button = el.closest('button')
      const anchor = el.closest('a.menu-link')
      const single_anchor = el.closest('a')
      const inputtag = document.querySelector<HTMLInputElement>('input[placeholder="Enter product URL"]')
      if (button || anchor || single_anchor || inputtag || el.closest('th') || el?.tagName === 'INPUT') {
        setDomButtonClicked((prev) => !prev)
      }
    }
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const tokenString: any = localStorage.getItem('kt-auth-react-v')
        const token = JSON.parse(tokenString)
        const userData: any = await axios.get(`${API_URL}/auth/verify-token`, {
          headers: {Authorization: `Bearer ${token?.access_token}`},
        })
        if (userData?.data?.statusCode === 200) {
          if (!userData?.data?.data?.status) {
            window.location.href = '/'
            localStorage.removeItem('microsoftAzure')
            localStorage.removeItem('azureLogoutcredential')
            localStorage.removeItem('newChannelAddedprompt')
            localStorage.removeItem('StopAPIRequest')
            localStorage.removeItem('SellercloudchannelStatus')
            localStorage.removeItem('priceScrapfilterdata')
            saveAuth(undefined)
            setCurrentUser(undefined)
            logout('false')
          }
        }
      } catch (error) {
        // checkError(error, logout);
      }
    }

    fetchUser()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domButtonClicked])
}
